var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.501 20C16.8295 21.2558 14.7516 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12C22.5 12.8634 22.3906 13.7011 22.1849 14.5003C21.9617 15.3673 21.0145 15.77 20.1699 15.4728C19.4519 15.2201 19.1221 14.3997 19.302 13.66C19.4314 13.1279 19.5 12.572 19.5 12C19.5 8.13401 16.366 5 12.5 5C8.63401 5 5.5 8.13401 5.5 12C5.5 15.866 8.63401 19 12.5 19C13.8197 19 15.054 18.6348 16.1076 18",
    fill: "#4E4E4E",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.501 20C16.8295 21.2558 14.7516 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12C22.5 12.8634 22.3906 13.7011 22.1849 14.5003C21.9617 15.3673 21.0145 15.77 20.1699 15.4728C19.4519 15.2201 19.1221 14.3997 19.302 13.66C19.4314 13.1279 19.5 12.572 19.5 12C19.5 8.13401 16.366 5 12.5 5C8.63401 5 5.5 8.13401 5.5 12C5.5 15.866 8.63401 19 12.5 19C13.8197 19 15.054 18.6348 16.1076 18",
    stroke: "#141B34",
    strokeOpacity: 0.1,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading02);
export default __webpack_public_path__ + "static/media/loading-02.7b96bb2beea72691a56f36dcf5ee8b39.svg";
export { ForwardRef as ReactComponent };